module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-06-d239fd46e8ff65dbbb3eea960fffbc11.jpg";